import React from "react";
import IconGInfo from "../../Resources/svg/Icons/IconGInfo";

const Tooltips = ({text}) => {
  return (
    <div className="tooltips">
      <IconGInfo />
      <div className="tooltips__message">
        <p>{text}</p>
      </div>
    </div>
  );
};

export default Tooltips;
